import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import UGC from '../../functional/UGC/UGC'
import * as Styled from './M024.styles'

/**
 * M024 is a User Generated Content(UGC) component that is populated via the Bazaarvoice curations api and Curralate, allowing customers to showcase the products they purchased or Recipes.
 */
const M024 = (props) => (
  <Styled.Container data-test='m024-container'>
    <ErrorBoundary>
      <UGC {...props} />
    </ErrorBoundary>
  </Styled.Container>
)

M024.propTypes = {
  /** required hashtag value, used to filter the curalate data */
  hashtag: PropTypes.string.isRequired,
  /** limits the number of data, used to filter the curalate data */
  limit: PropTypes.number,
  /** Used in the mini version as the link title */
  linkTitle: PropTypes.string,
  /** Used in the mini version as the View more link url */
  linkUrl: PropTypes.string,
  /** Used for the content filter pills */
  tags: PropTypes.arrayOf(PropTypes.string),
  /** Label for the product tab */
  productTab: PropTypes.string
}

M024.defaultProps = {
  limit: 50,
  linkTitle: 'View More',
  linkUrl: '',
  productTab: 'Shop these products'
}

export default M024
